<template>
  <div></div>
</template>

<script>
import { common } from "@/model/common";

export default {
  name: "auth",
  components: {},
  methods() {},
  mounted() {},
  created() {
    common.platform = common.isMobile == 1 ? "wap" : "pc";
    common.routerReplace(this, "login");
  },
};
</script>
